export default "__VITE_PUBLIC_ASSET__ab4fb87f__"